namespace TabAurous.OMS {
    export interface CitiesMasterForm {
        StateId: Serenity.LookupEditor;
        Name: Serenity.StringEditor;
    }

    export class CitiesMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.CitiesMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CitiesMasterForm.init)  {
                CitiesMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(CitiesMasterForm, [
                    'StateId', w0,
                    'Name', w1
                ]);
            }
        }
    }
}
